import React, { useEffect, useState } from "react";
import { Colors } from "../../config";
import { BarChart } from "@mui/x-charts/BarChart";

const colors = ["#FFF0C8", "#B3FCC4", "#d1f1fb", "#fbe0e0"];
const colorsStroke = ["#F6BF27", "#22B945", "#2DAED6", "#C45A56"];

const HorizontalBarChartSingle = (props) => {
  const [height, setHeight] = useState(180);

  useEffect(() => {
    const updateFontSize = () => {
      if (window.innerWidth >= 2133) {
        setHeight(200);
      } else if (window.innerWidth < 2133 && window.innerWidth >= 1920) {
        setHeight(180);
      } else if (window.innerWidth < 1920 && window.innerWidth >= 1745) {
        setHeight(160);
      } else if (window.innerWidth < 1745 && window.innerWidth >= 1536) {
        setHeight(130);
      } else if (window.innerWidth < 1536 && window.innerWidth >= 1280) {
        setHeight(110);
      } else {
        setHeight(180);
      }
    };
    updateFontSize();
    window.addEventListener("resize", updateFontSize);

    return () => window.removeEventListener("resize", updateFontSize);
  }, []);

  return (
    <BarChart
      skipAnimation={false}
      height={height}
      borderRadius={4}
      barSize={10}
      barLabel="value"
      layout="horizontal"
      bottomAxis={{
        disableTicks: true,
        disableLine: true,
        tickLabelStyle: {
          display: "none",
        },
      }}
      leftAxis={{
        disableTicks: true,
        disableLine: true,
        tickLabelStyle: {
          fontSize: "0.75em",
          fontWeight: "700",
          // display: "none",
        },
      }}
      sx={{
        [`.css-nsbw82-MuiChartsLegend-root`]: {
          display: "none",
        },
      }}
      slotProps={{
        bar: (index) => ({
          style: {
            fill: colors[index.dataIndex] || Colors.main,
            stroke: colorsStroke[index.dataIndex] || Colors.main,
            strokeWidth: "0.125em",
            clipPath: "inset(0 0 0 0 round 0.3125em)",
          },
        }),
        // barLabel: (index) => ({
        //   style: {
        //     fontSize: "0.75em",
        //     fontWeight: "bold",
        //     fill: "#000",
        //     transform: "translate3d(21.875em, 1px, 0.625em)",
        //   },
        // }),
      }}
      grid={{ vertical: true, horizontal: true }}
      margin={{ top: 1, right: 1, bottom: 0, left: 70 }}
      tooltip={null}
      {...props}
    />
  );
};

export default HorizontalBarChartSingle;
